import * as React from 'react';
import * as styles from './Rating.css';

interface IRatingProps {
  chart: React.ReactNode;
  label: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode;
}

export function Rating({ chart, label, title, description }: IRatingProps) {
  return (
    <div className={styles['rating']}>
      <div className={styles['rating__graph']}>
        {chart}

        <span className={styles['rating__graph-label']}>{label}</span>
      </div>
      <div className={styles['rating__title']}>{title}</div>
      {description && <div className={styles['rating__description']}>{description}</div>}
    </div>
  );
}
